import $ from 'jquery';
import {sessionInfoInitializedP} from 'module/SessionInfo/api/SessionInfoAPI';

export const appReady = sessionInfoInitializedP.then(() => new Promise(resolve => $(document).ready(resolve)));